module.exports = __webpack_public_path__ + "static/gphe-plyta-189f1103edc442b4fec3d8082ffb573b.png";